export default __webpack_public_path__ + "static/media/appleWallet.1c29cb02.svg";